import { StatementFormModel } from './StatementFormModel';
import { StatementFileInfoModel } from './StatementFileInfoModel';
import { StatementInfoModel } from './StatementInfoModel';
import { StatementStatusHistoryModel } from './StatementStatusHistoryModel';

export class StatementModel
{
	public Id: string = '';
	public StatementPrevNumber: string | undefined = undefined;
	public StatementPrevDate: string | undefined = undefined;
	public StatementType: string = '';
	public FeedbackEmail: string = '';
	public OrganizationName: string = '';
	public OrganizationInn: string = '';
	public OrganizationKpp: string = '';
	public OrganizationHeadFirstName: string = '';
	public OrganizationHeadLastName: string = '';
	public OrganizationHeadSecondName: string | undefined = undefined;
	public OrganizationHeadSecondNameExists: boolean = true;
	public OrganizationHeadPosition: string = '';
	public Comments: string | undefined = undefined;
	public StatusId: string = '';
	public AgreementCheck: boolean = false;
	public LinkReadonly: string | undefined = undefined;
	public LinkClarify: string | undefined = undefined;
	public CreateDate: string = "";
	public FormTrigger: boolean = false;

	public Form: StatementFormModel = new StatementFormModel();
	public StatementFileInfos: StatementFileInfoModel[] = [];
	public StatementInfos: StatementInfoModel[] = [];
	public StatementStatusHistory: StatementStatusHistoryModel[] = [];
}
